<template>
  <div class="card">
    <Toast position="top-right" />
    <ConfirmDialog></ConfirmDialog>
    
    <Toolbar class="mb-4">
      <template #start>
        <h1 class="text-2xl font-bold">Asignación de Ubicaciones a Usuarios</h1>
      </template>
      <template #end>
        <div class="grid">
          <div class="col-6">
            <Dropdown id="estado"
                      v-model="estadoSeleccionado"
                      :options="estados"
                      optionLabel="Nombre"
                      optionValue="Id_estado"
                      placeholder="Seleccione un estado"
                      @change="filtroEstado(estadoSeleccionado)" 
                      :filter="true"/>
            <small class="p-error" v-if="submitted && !asignacion.Id_estado">Estado es requerido.</small>
          </div>
          <div class="col-6">
            <Button label="Nueva Asignación" icon="pi pi-plus" class="p-button-success" @click="openNew" />
          </div>
        </div>
      </template>
    </Toolbar>

    <DataTable :value="asignaciones" :loading="loading" :paginator="true" :rows="10"
               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
               :rowsPerPageOptions="[5,10,25]"
               currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} asignaciones"
               responsiveLayout="scroll">
      <template #empty>
          <span class="text-center p-4">No hay usuarios asignados a este estado.</span> 
      </template>
      <Column field="Matricula" header="Matrícula" sortable></Column>
      <Column field="Usuario" header="Usuario" sortable></Column>
      <Column field="estadoNombre" header="Estado" sortable>
        <template #body="slotProps">
          <Tag :value="slotProps.data.estadoNombre" :severity="getSeverity(slotProps.data.Id_estado)" />
        </template>
      </Column>
      <Column field="delegaciones" header="Delegaciones Asignadas">
        <template #body="slotProps">
          <div v-if="slotProps.data.todasDelegaciones" class="flex align-items-center">
            <i class="pi pi-exclamation-triangle mr-2 text-yellow-500"></i>
            <span>Sin delegaciones asignadas</span>
          </div>
          <div v-else>
            <Chip v-for="del in slotProps.data.delegaciones" :key="del.Id_delegacion" 
                  :label="del.Descripcion" class="mr-2 mb-2" />
          </div>
        </template>
      </Column>
      <Column header="Acciones" headerStyle="width: 120px; text-align: center" bodyStyle="text-align: center">
        <template #body="slotProps">
          <Button icon="pi pi-pencil" class="p-button-rounded p-button-success" style="margin-right: 5px;"
                  @click="editAsignacion(slotProps.data)" />
          <Button icon="pi pi-trash" class="p-button-rounded p-button-danger" 
                  @click="confirmDelete(slotProps.data)" />
        </template>
      </Column>
    </DataTable>

    <!-- Diálogo para asignar ubicaciones -->
    <Dialog v-model:visible="asignacionDialog" :style="{width: '750px'}" header="Asignar Ubicaciones" :modal="true">
      <div class="p-fluid grid">

        <div class="p-field col">
          <label for="usuario">Usuario <span class="text-red-500">*</span></label>
            <Dropdown 
              id="tipo" 
              v-model="asignacion.Id_usuario" 
              :options="lstUsuarios" 
              optionLabel="labelUsuario"
              optionValue="Id_usuario"
              placeholder="Selecciona un usuario"
              @change="onUsuarioChange"
              :class="{ 'p-invalid': submitted && !asignacion.Id_usuario, }"
              :filter="true"/>
          <small class="p-error" v-if="submitted && !asignacion.Id_usuario">Usuario es requerida.</small>
        </div>

        <div class="field col-12">
          <label for="estado">Estado <span class="text-red-500">*</span></label>
            <Dropdown 
              id="estado" 
              v-model="asignacion.Id_estado" 
              :options="estados" 
              optionLabel="Nombre" 
              optionValue="Id_estado" 
              placeholder="Seleccione un estado" 
              :class="{'p-invalid': submitted && !asignacion.Id_estado}"
              @change="onEstadoChange"
              :filter="true">
          </Dropdown>
          <small class="p-error" v-if="submitted && !asignacion.Id_estado">Estado es requerido.</small>
        </div>

        <div class="field col-12">
          <label>Seleccione delegaciones específicas (opcional)</label>
          <small class="block mb-3 text-gray-500">Si no selecciona ninguna, se asignarán todas las delegaciones del estado</small>
          
          <DataTable v-if="delegacionesEstado.length > 0" 
                    :value="delegacionesEstado" v-model:selection="asignacion.delegacionesSeleccionadas" 
                    selectionMode="multiple" dataKey="Id_delegacion" :scrollable="true" scrollHeight="200px"
                    :loading="loadingDelegaciones" class="p-datatable-sm">
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column field="No_delegacion" header="No."></Column>
            <Column field="Descripcion" header="Descripción"></Column>
            <Column field="Titular" header="Titular"></Column>
            <template #empty>
              No se encontraron delegaciones para este estado
            </template>
          </DataTable>
          <div v-else class="p-4 text-center text-gray-500">
            No hay delegaciones registradas para este estado
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
        <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveAsignacion" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import DelegacionesService from '../../service/DelegacionesService';
import EstadosService from '../../service/EstadosService';
import UsuariosUbicaciones from '../../service/UsuariosUbicaciones';
export default {
  data() {
    return {
      estadosService: new EstadosService(),
      delegacionesService: new DelegacionesService(),
      usuariosUbicaciones : new UsuariosUbicaciones(),
      asignaciones: [],
      asignacionesOriginales: [],
      estados: [],
      lstUsuarios: [],
      delegacionesEstado: [],
      asignacionDialog: false,
      estadoSeleccionado: false,
      noHayEstados: false,
      asignacion: {
        matricula: null,
        Id_estado: null,
        delegacionesSeleccionadas: [],
        delegacionesOriginales: []
      },
      submitted: false,
      loading: false,
      loadingDelegaciones: false,
    }
  },
  created() {
    this.cargarEstados();
    this.cargarAsignaciones();
    this.obtenerUsuariosPorSistema();
  },
  methods: {
    cargarEstados() {
      this.loading = true;
      this.estadosService.getEstados().then(res => {
        this.estados = res;
      }).finally(() => this.loading = false);
    },

    filtroEstado(id_estado) {
      this.noHayEstados = false
      this.asignaciones = this.asignacionesOriginales;
      const resultadosFiltrados = this.asignaciones.filter(asig => asig.Id_estado === id_estado);

      this.asignaciones = resultadosFiltrados;

      if (resultadosFiltrados.length === 0) {
        this.noHayEstados = true
      }
    },

    cargarAsignaciones() {
      this.loading = true;
      this.usuariosUbicaciones.getAsignaciones().then(res => {
        this.asignaciones = res;
        this.asignacionesOriginales = res;
      }).finally(() => this.loading = false);
    },

    onUsuarioChange() {
      this.asignacion.delegacionesSeleccionadas = [];
      this.asignacion.delegacionesOriginales = [];
      
      if (this.asignacion.Id_usuario && this.asignacion.Id_estado) {
        const asignacionExistente = this.asignaciones.find(
          a => a.Id_usuario === this.asignacion.Id_usuario && 
              a.Id_estado === this.asignacion.Id_estado
        );

        if (asignacionExistente) {
          this.asignacion.delegacionesOriginales = asignacionExistente.delegaciones;
          const delegacionesCompletas = this.delegacionesEstado.filter(d => 
            asignacionExistente.delegaciones.some(
              selected => selected.Id_delegacion === d.Id_delegacion
            )
          );
          this.asignacion.delegacionesSeleccionadas = delegacionesCompletas;
        }
      }
    },

    onEstadoChange() {
      this.asignacion.delegacionesSeleccionadas = [];
      this.delegacionesEstado = [];
      
      if (this.asignacion.Id_estado) {
        this.loadingDelegaciones = true;
        
        this.delegacionesService.getDelegacionesPorEstado(this, this.asignacion.Id_estado)
          .then(res => {
            this.delegacionesEstado = res || [];
            
            if (this.asignacion.Id_usuario) {
              const asignacionExistente = this.asignaciones.find(
                a => a.Id_usuario === this.asignacion.Id_usuario && 
                    a.Id_estado === this.asignacion.Id_estado
              );

              if (asignacionExistente) {
                this.asignacion.delegacionesOriginales = asignacionExistente.delegaciones;
                const delegacionesCompletas = this.delegacionesEstado.filter(d => 
                  asignacionExistente.delegaciones.some(
                    selected => selected.Id_delegacion === d.Id_delegacion
                  )
                );
                this.asignacion.delegacionesSeleccionadas = delegacionesCompletas;
              }
            }
          })
          .finally(() => {
            this.loadingDelegaciones = false;
          });
      }
    },

    openNew() {
      this.asignacion = {
        matricula: null,
        Id_usuario: null,
        Id_estado: null,
        delegacionesSeleccionadas: [],
        delegacionesOriginales: []
      };
      this.delegacionesEstado = [];
      this.submitted = false;
      this.asignacionDialog = true;
    },

    hideDialog() {
      this.asignacionDialog = false;
      this.submitted = false;
      this.asignacion = {
        matricula: null,
        Id_usuario: null,
        Id_estado: null,
        delegacionesSeleccionadas: [],
        delegacionesOriginales: []
      };
      this.delegacionesEstado = [];
    },

    obtenerUsuariosPorSistema() {
      var t = this;
      var ctlSvr = new DelegacionesService();

      ctlSvr.getUsuariosPorSistema(t).then((res) => {
        t.lstUsuarios = res.map(u => ({
          ...u,
          labelUsuario: `${u.Usuario} - ${u.Ap_pat} ${u.Ap_mat} ${u.Nombres}  (${u.Matricula})`
        }));
      });
    },
    
    editAsignacion(asignacion) {
      this.asignacion = {
        Matricula: asignacion.matricula,
        Id_usuario: asignacion.Id_usuario,
        Id_estado: asignacion.Id_estado,
        delegacionesSeleccionadas: asignacion.delegaciones,
        delegacionesOriginales: asignacion.delegaciones
      };
    
      this.cargarDelegacionesPorEstado().then(() => {
        const delegacionesCompletas = this.delegacionesEstado.filter(d => 
          asignacion.delegaciones.some(selected => selected.Id_delegacion === d.Id_delegacion)
        );
        this.asignacion.delegacionesSeleccionadas = delegacionesCompletas;
        
        this.asignacionDialog = true;
      });
    },

    cargarDelegacionesPorEstado() {
      let t = this;
      
      if (!t.asignacion.Id_estado) {
        t.delegacionesEstado = [];
        return Promise.resolve();
      }
      
      this.loadingDelegaciones = true;
      
      return this.delegacionesService.getDelegacionesPorEstado(t, t.asignacion.Id_estado)
        .then(res => {
          t.delegacionesEstado = res || [];
        })
        .finally(() => {
          this.loadingDelegaciones = false;
        });
    },
    
    saveAsignacion() {
      let t = this;
      this.submitted = true;

      t.asignacion.matricula = this.lstUsuarios.find(
        (usuario) => usuario.Id_usuario == t.asignacion.Id_usuario
      )?.Matricula;
      
      if (!this.asignacion.matricula || !this.asignacion.Id_estado || !this.asignacion.Id_usuario) {
        return;
      }
    
      let payload = [];
      let delegacionesEliminadas = [];
      
      if(t.asignacion.delegacionesOriginales && t.asignacion.delegacionesOriginales.length > 0) {
        delegacionesEliminadas = t.asignacion.delegacionesOriginales
          .filter(delegacionOriginal => !t.asignacion.delegacionesSeleccionadas
            .some(delegacionSeleccionada => 
              delegacionSeleccionada.Id_delegacion === delegacionOriginal.Id_delegacion
            ))
          .map(delegacion => ({
            Id_usuario: t.asignacion.Id_usuario,
            Id_delegacion: delegacion.Id_delegacion,
            Id_estado: t.asignacion.Id_estado
          }));
      }
      
      if(t.asignacion.delegacionesSeleccionadas.length > 0) {
        const delegacionesActuales = this.asignaciones
          .find(a => a.Id_usuario === t.asignacion.Id_usuario && a.Id_estado === t.asignacion.Id_estado)
          ?.delegaciones || [];
        
        const delegacionesNuevas = t.asignacion.delegacionesSeleccionadas.filter(
          delegacionNueva => !delegacionesActuales.some(
            delegacionActual => delegacionActual.Id_delegacion === delegacionNueva.Id_delegacion
          )
        );
    
        delegacionesNuevas.forEach(delegacion => {
          payload.push({
            Matricula: this.asignacion.matricula,
            Id_usuario: this.asignacion.Id_usuario,
            Id_estado: this.asignacion.Id_estado,
            Id_delegacion: delegacion.Id_delegacion
          });
        });
      } else {
        payload.push({
          Matricula: this.asignacion.matricula,
          Id_usuario: this.asignacion.Id_usuario,
          Id_estado: this.asignacion.Id_estado
        });
      }
    
      if (payload.length === 0 && delegacionesEliminadas.length === 0) {
        this.$toast.add({
          severity: 'info',
          summary: 'Información',
          detail: 'No hay cambios para aplicar',
          life: 3000
        });
        this.hideDialog();
        return;
      }
    
      this.loading = true;

      if(delegacionesEliminadas.length > 0) {
        t.usuariosUbicaciones.eliminarDelegaciones(t, delegacionesEliminadas).then(() => {
          if(payload.length === 0) {
            this.$toast.add({
              severity: 'success',
              summary: 'Éxito',
              detail: 'Delegaciones eliminadas correctamente',
              life: 3000
            });
            this.cargarAsignaciones();
            this.asignacion.delegacionesSeleccionadas = [];
            this.asignacion.delegacionesOriginales = [];
            this.hideDialog();
            return;
          }
        });
      }
      
      if(payload.length > 0) {
        t.usuariosUbicaciones.Add(t,payload).then(() => {
          this.$toast.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Asignación guardada correctamente',
            life: 3000
          });
          this.cargarAsignaciones();
          this.hideDialog();
        }).catch(error => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: error.response?.message || 'Error al guardar la asignación',
            life: 3000
          });
        }).finally(() => this.loading = false);
      }
    },
    
    confirmDelete(asignacion) {
      this.$confirm.require({
        message: `¿Está seguro de eliminar la asignación para ${asignacion.matricula}?`,
        header: 'Confirmar eliminación',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.deleteAsignacion(asignacion);
        }
      });
    },
    
    deleteAsignacion(asignacion) {
      let t = this;
      this.loading = true;

      if(asignacion.delegaciones.length === 0) {
        asignacion.delegaciones = [{
          Id_usuario: asignacion.Id_usuario,
          Id_estado: asignacion.Id_estado,
          Id_delegacion: 0,
        }];
      } else{
        asignacion.delegaciones.forEach(del => {
          del.Id_usuario = asignacion.Id_usuario;
          del.Id_estado = asignacion.Id_estado;
        });
      }

      this.usuariosUbicaciones.eliminarDelegaciones(t, asignacion.delegaciones).then(() => {
        this.$toast.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Delegaciones eliminadas correctamente',
          life: 3000
        });
        this.cargarAsignaciones();
        this.asignacion.delegacionesSeleccionadas = [];
        this.asignacion.delegacionesOriginales = [];
        this.hideDialog();
        return;
      });
    },
    
    getSeverity(idEstado) {
      const severities = ['success', 'info', 'warning', 'danger'];
      return severities[idEstado % severities.length] || 'info';
    }
  }
}
</script>

<style scoped>
:deep(.p-datatable) {
  font-size: 0.9rem;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background-color: var(--surface-50);
  font-weight: 600;
}

.tag-estado {
  min-width: 80px;
  text-align: center;
}
</style>